import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { CompanyTypeClass } from "../../../shared/models/company-type";
import { RequestStatusClass } from "../../../shared/models/request-status";
import { AuthGuardService } from "../../../shared/services/auth-guard.service";
import { RequestFormService } from "../request-form/request-form.service";
import { Location } from "../../../shared/models/location";

@Component({
  selector: "app-request-filter",
  templateUrl: "./request-filter.component.html",
  styleUrls: ["./request-filter.component.css"],
})
export class RequestFilterComponent implements OnInit {
  @Output() onFilter = new EventEmitter<any>();

  disableCompanyType;
  selectedCompanyType;
  disableCompany;
  selectedCompany;

  companyTypeList;
  companyList = [];
  companyListByType = {};
  locationList;
  requestStatusList;

  constructor(
    private requestFormService: RequestFormService,
    private authGuardService: AuthGuardService
  ) { }

  ngOnInit() {
    this.companyList = [{ nameEn: "Select Company", symbol: "" }];

    this.companyTypeList = CompanyTypeClass.list();
    this.companyTypeList.unshift({ key: null, value: "Select Type" });
    this.requestStatusList = RequestStatusClass.search();
    this.requestStatusList.unshift({ key: null, value: "Select a Status" });
    this.requestFormService.listCompanyByType("B").subscribe((companies) => {
      this.companyListByType["B"] = companies;
      this.companyListByType["B"].unshift({
        nameEn: "Select Company",
        symbol: "",
      });

      this.requestFormService.listCompanyByType("V").subscribe((companies) => {
        this.companyListByType["V"] = companies;
        this.companyListByType["V"].unshift({
          nameEn: "Select Company",
          symbol: "",
        });

        this.requestFormService
          .listCompanyByType("Y")
          .subscribe((companies) => {
            this.companyListByType["Y"] = companies;
            this.companyListByType["Y"].unshift({
              nameEn: "Select Company",
              symbol: "",
            });

            this.requestFormService
              .listCompanyByType("Z")
              .subscribe((companies) => {
                this.companyListByType["Z"] = companies;
                this.companyListByType["Z"].unshift({
                  nameEn: "Select Company",
                  symbol: "",
                });

                if (this.authGuardService.isAuthenticated()) {
                  if (this.authGuardService.isDcaInternal()) {
                    // do nothing, can select all
                  } else if (this.authGuardService.isDcaMember()) {
                    let userProfile = this.authGuardService.getUserProfileInformation();
                    this.selectedCompanyType = CompanyTypeClass.getObjectFromEnum(
                      userProfile.company.companyType
                    );
                    this.disableCompanyType = true;
                    this.filterCompanyType(userProfile.company.companyType);
                    this.selectedCompany = userProfile.company;
                    this.disableCompany = true;
                  } else {
                    // throw error no role
                  }
                } else {
                  // throw error not authenticated
                }
              });
          });
      });
    });
    this.requestFormService.listLocations().subscribe((locations) => {
      this.locationList = [...locations];
      this.locationList = this.locationList.map((lo: Location) => ({ ...lo, name: `${lo.site}: ${lo.name}` }))
      this.locationList.unshift({ name: "Select a Location", id: null });
    });
  }

  filterCompanyType(companyType) {
    this.companyList = this.companyListByType[companyType];
    this.doFilter(null, "company.symbol", "equals");
  }

  doFilter(value, columnName, filterType) {
    this.onFilter.emit({
      value: value,
      columnName: columnName,
      filterType: filterType,
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/modules/request/request-filter/request-filter.component.ts